import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppConfigService } from 'app/shared/service/app-config.service';
import { EntityService } from 'app/shared/service/entity.service';
import { Criteria } from 'app/shared/utils/criteria.model';
import { IEntityInfo } from '@briebug/ngrx-auto-entity';

import { Observable } from 'rxjs';
import { map, mergeMap } from 'rxjs/operators';

import { Groupe } from './groupe.model';


@Injectable()
export class GroupeService extends EntityService<Groupe> {

    constructor(private _http: HttpClient, private _configService: AppConfigService) {
        super(_http, _configService);
    }
/*
    loadAllSelectt(criteria?: Criteria): Observable<Groupe[]> {
        let response: Observable<any[]>
        if (criteria) {
            let params: HttpParams = new HttpParams();
            if (criteria && criteria.sort) {
                params = params.set("sort", criteria.sort.field)
                    .set("dir", criteria.sort.dir);
            }
            response = this._http.post<Groupe[]>(`${this._configService.config.apiUrl}/groupes/select-items`, criteria.filter, { params: params });
        } else {
            response = this._http.post<Groupe[]>(`${this._configService.config.apiUrl}/groupes/select-items`, null);
        }

        return response.pipe(
            map(items => {
                for (let item of items) {
                    item.pays = new Pays();
                    item.pays.id = item.paysId;
                }
                return items;
            }));
            
    }
    */
   
    create(entityInfo: IEntityInfo, entity: Groupe): Observable<Groupe> {
        let groupe$: Observable<Groupe> = super.create(entityInfo, entity);
        if (entity.users && entity.users.length > 0) {
            return this.saveGroupe(groupe$, entityInfo, entity);
        }
        return groupe$;
    }

    private saveGroupe(poste$: Observable<Groupe>, entityInfo: IEntityInfo, entity: Groupe): Observable<Groupe> {
        return poste$.pipe(
            mergeMap(poste => {
                let employeesIds = entity.users.map(emp => emp.id);
                return this._http.put<Groupe>(
                    `${this._configService.config.apiUrl}/${this.getEntityUri(entityInfo)}/${poste.id}/users`,
                    employeesIds);
            })
        );
    }
}